import type { QueryClient } from '@tanstack/react-query';

import type { User } from '../../domain/user';

import userQueryKey from './userQueryKey';

export interface UserRepository {
  getUser: () => User | undefined;

  setUser: (user: User) => User | undefined;

  isDataCreditsEnabled: boolean;
}

export const makeUserRepository = (queryClient: QueryClient): UserRepository => ({
  getUser: () => queryClient.getQueryData<User>(userQueryKey.userInfo()),

  setUser: (user: User) => queryClient.setQueryData<User>(userQueryKey.userInfo(), user),

  get isDataCreditsEnabled() {
    const user = queryClient.getQueryData<User>(userQueryKey.userInfo());

    return user?.isDataCreditsEnabled ?? false;
  },
});
